module.exports = __webpack_public_path__ + "static/media/mtron.a813db9f.pdf";